module.exports = "/_next/static/images/c128514a83f4e29ebc1e76385bd4531d-mockup-conta-fgts@0.75x.jpg.webp";